import axios from 'axios';

const SERVICE_URL_EMPS = '/empresas/';
const RECEIVE_EMPS = 'RECEIVE_EMPS';
const RECEIVE_EMPSCI = 'RECEIVE_EMPSCI';


const state = {
  empresas: [],
  empresasCI: []
};

const borra = { me: null };
function putoIEAssign(o, k, v) {
  borra.me = o[k];
  o[k] = v;
  delete borra.me;
}

const getters = {
  empresas: state => state.empresas,
  empresasCI: state => state.empresasCI,
};

const actions = {
  getCompanyContractsInventory({ commit }) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
    return axios
      .get(
        `${SERVICE_URL_EMPS}companyContractWithOutInventory/${JSON.parse(localStorage.getItem('role')).faena_id}`,
        config,
      )
      .then((response) => {
        commit(RECEIVE_EMPSCI, response.data);
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },
  resetEmpresasFaena({ commit }) {
    commit(RECEIVE_EMPS, []);
  },
  getEmpresasFaena({ commit }) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
    return axios.get(`${SERVICE_URL_EMPS}faena/${JSON.parse(localStorage.getItem('role')).faena_id}`, config)
      .then((response) => {
        commit(RECEIVE_EMPS, response.data);
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },

  getEmpresasByFaena({ commit }, faena_id) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
    return axios.get(`${SERVICE_URL_EMPS}faena/${faena_id}`, config)
      .then((response) => {
        commit(RECEIVE_EMPS, response.data);
      })
      .catch((error) => {
        if (error) {
          console.log(error);
        }
      });
  },

  editEmpresa({ commit }, emp) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(`${SERVICE_URL_EMPS}edit`, emp, config)
        .then((response) => {
          if (!response.data.success) {
            resolve(response.data.message);
          } else {
            resolve(true);
          }
        });
    });
  },

  saveEmpresa({ commit }, nuevo) {
    return new Promise((resolve) => {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      axios.post(`${SERVICE_URL_EMPS}crear`, nuevo, config)
        .then((response) => {
          if (!response.data.success) {
            resolve(response.data.message);
          } else {
            resolve(true);
          }
        });
    });
  },
};

const mutations = {
  [RECEIVE_EMPS](state, emps) {
    putoIEAssign(state, 'empresas', emps);
  },
  [RECEIVE_EMPSCI](state, emps) {
    state.empresasCI = emps;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
